module.exports = __webpack_public_path__ + "static/media/microphone-stand.7c7dec95.svg";